import gql from "graphql-tag";

export default gql`
  query {
    sensors {
      id
      name
      unit
      lastMeasurement
    }
  }
`;
